import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

const ListItemCheckbox = ({
  type,
  id,
  item,
  selectedItems,
  handleSelectItem,
  authUser,
}) => {
  const location = useLocation();
  const userType = Number(authUser?.UserTypeID);

  // Block if: Not User 5 AND (Not on restricted list OR on wrong path)
  const isUser5 = userType === 5;
  const isRestrictedUser = userType === 1 || userType === 6;
  const isCorrectLocation = location.pathname === "/admin/result";

  const hasAccess = isUser5 || (isRestrictedUser && isCorrectLocation);
  // If the user shouldn't see it, return null to render nothing
  if (!hasAccess) return null;
  let isChecked = false;
  let handleChange = () => {};

  if (type === "assessment") {
    // Assessment logic (array of objects)
    isChecked = selectedItems.some(
      (selected) => selected.AssessmentID === item.AssessmentID,
    );
    handleChange = () =>
      handleSelectItem(item.AssessmentID, item.SchoolID, item.CategoryID);
  } else {
    // School logic (array of IDs)
    isChecked = selectedItems.includes(id); // falls back depending on your data key
    handleChange = () => handleSelectItem(id);
  }
  //   const isChecked = selectedItems.includes(id);

  return (
    <div className="school-checkbox-column">
      <input
        type="checkbox"
        className={`me-3 form-check-input ${isChecked ? "checkbox-success" : ""}`}
        checked={isChecked}
        onChange={handleChange}
      />
    </div>
  );
};
const mapStateToProps = (state) => ({
  authUser: state.auth.user,
});
export default connect(mapStateToProps)(ListItemCheckbox);
